//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false, _: false */

(function() {
  const curalate = angular.module('curalate');

  curalate.service('FanreelAnalyticsService', [
    '$http',
    '$q',
    'PromiseService',
    function(
            $http,
            $q,
            PromiseService,
        ) {
      this.getBaseStatsUrl = function(reelId) {
        return `/api/reels/${reelId}/stats/`;
      };

      this.getReelStatsMetadataAsync = function(reelId, params) {
        return this.getReelStatsDataAsync(reelId, 'metadata', params);
      };

      this.getReelStatsDataAsync = function(reelId, endpoint, params) {
        const urlPath = this.getBaseStatsUrl(reelId) + endpoint;
        return PromiseService.processHttpResponse($http.get(urlPath, { params }));
      };

      this.getReelLevelSummaryStatsAsync = function(reelId, params) {
        return this.getReelStatsDataAsync(reelId, 'reel', params);
      };

      this.getReelDailyChartStatsAsync = function(reelId, params) {
        return this.getReelStatsDataAsync(reelId, 'graph', params);
      };

      this.getReelItemStatsAsync = function(reelId, params) {
        return this.getReelStatsDataAsync(reelId, 'items', params);
      };

      this.getReelContributorStatsAsync = function(reelId, params) {
        return this.getReelStatsDataAsync(reelId, 'contributors', params);
      };

      this.getReelProductStatsAsync = function(reelId, params) {
        return this.getReelStatsDataAsync(reelId, 'products', params);
      };

            //
            // Fanreel Analytics CSV Export URLs
            //

      this.getExportUrl = function(reelId, datesString, desiredFiles, testVariation) {
        const baseUrl = `${this.getBaseStatsUrl(reelId)}export.csv`;
        const datesParam = `dateRange=${datesString}`;
        const filesParam = `files=${desiredFiles.join(',')}`;
        const testVariationParamOpt = testVariation ? `&testVariation=${testVariation}` : '';

        return `${baseUrl}?${datesParam}&${filesParam}${testVariationParamOpt}`;
      };
    },
  ]);
})();
